<template>
  <div class="cc-logo-container">
      <a href="https://www.code-crew.de/" target="_blank">
        <img v-if="type === 'black'" src="https://logos.code-crew.de/cc_logo_black.png">
        <img v-if="type === 'white'" src="https://logos.code-crew.de/cc_logo_white.png">
      </a>
  </div>
</template>

<script>
export default {
	name: 'LogoItem',
	props: {
		type: String,
	},
};
</script>

<style src="@/styles/components/LogoItem/LogoItem.less" lang="less" scoped></style>

